import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@env/environment';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vc-product-seller-badge',
  templateUrl: './product-seller-badge.component.html',
  styleUrls: ['./product-seller-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ProductSellerBadgeComponent implements OnChanges {
  @Input()
  seller: any;
  @Input()
  showTooltip = false;

  hasImg = false;
  firstLetter: string;
  imgixPath = environment.imgixPath;
  public hasSellerRating = environment.feature.seller_rating;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.seller) {
      this.firstLetter = changes.seller.currentValue.firstname.charAt(0);
      if (changes.seller.currentValue.picture) {
        if (changes.seller.currentValue.picture.path !== '' && changes.seller.currentValue.picture.path) {
          this.hasImg = true;
        }
      }
    }
  }

  stopPropagation(event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
